import abortionDeclaration      from './abortionDeclaration'
import abortionSerieDeclaration from './abortionSerieDeclaration'

export default
{
    abortionDeclaration,
    abortionSerieDeclaration
};
